import { useAuth } from "../../../../context/AuthContext";
import ViewProject from "../project-crud/ViewProject";
import ViewAmsProject from "../../../amsProject/pages/project-crud/ViewAmsProject";

export default function ProjectViewRouter() {
    const { activeDepartment } = useAuth();

    if (activeDepartment === 'AMS') {
        return <ViewAmsProject />;
    }

    return <ViewProject />;
}
